import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { currencyFormat } from '../../../services/utils';
import { usePetPolicies } from '../../../hooks/usePetPolicies';

import Shimmer from '../../common/Shimmer';
import { CoverageOverviewField } from './CoverageOverviewField';
import './css/CoverageOverview.css';
import { formatShortDateByLanguage } from '../../../services/language.utils';

const CoverageGroupInfoFee = ({
  isCancelled = false,
  selectedPolicy = {},
}) => {
  const petPolicies = usePetPolicies();
  const { loading } = petPolicies;
  const { t } = useTranslation('insurance');
  // TBD business logic
  const showOnePackDisclaimer = false;

  const {
    Benefit = '',
    CancellationDate = '',
    Copay = '',
    Deductible = '',
    IncidentLimit = '',
    PetCoverages = '',
    PolicyDisplayNumber = '',
    PolicyEndDate = '',
    PolicyStartDate = '',
    ProductName = '',
    TotalPremium = '',
    GroupName = '',
  } = selectedPolicy;

  function renderShimmer() {
    return (
      <div className="Flex Flex-column">
        <Shimmer className="Coverage-overview-info-shimmer" visible />

        <Shimmer className="Coverage-overview-info-shimmer" visible />

        <Shimmer className="Coverage-overview-info-shimmer" visible />

        <Shimmer className="Coverage-overview-info-shimmer" visible />
      </div>
    );
  }

  function renderContent() {
    if (isCancelled) {
      const payAmount = TotalPremium
        || TotalPremium === 0
        ? `$${TotalPremium.toFixed(2)}` : t('na');

      return (
        <CoverageGroupInfoFee
          cancellationDate={formatShortDateByLanguage(CancellationDate)}
          effectiveDate={formatShortDateByLanguage(PolicyStartDate)}
          payAmount={payAmount}
          policyNumber={PolicyDisplayNumber}
        />
      );
    }

    return (
      <>
        <div className="Coverage-overview-column">
          <CoverageOverviewField
            label={t('product')}
            value={ProductName}
          />

          <CoverageOverviewField
            label={t('coveragePeriod')}
            value={`${formatShortDateByLanguage(PolicyStartDate)} - 
            ${formatShortDateByLanguage(PolicyEndDate)}`}
          />

          <CoverageOverviewField
            label={t('coinsurance')}
            value={`${Copay}%`}
          />
        </div>

        <div className="Coverage-overview-column">
          <CoverageOverviewField
            label={t('certificateNumber')}
            value={PolicyDisplayNumber}
          />

          <CoverageOverviewField
            label={t('incidentLimit')}
            value={currencyFormat({ value: IncidentLimit })}
          />

          <CoverageOverviewField
            label={t('deductible')}
            value={currencyFormat({ value: Deductible })}
          />
        </div>

        <div className="Coverage-overview-column">
          <CoverageOverviewField
            label={t('groupName')}
            value={GroupName}
          />

          <CoverageOverviewField
            label={t('coverageLimit')}
            value={currencyFormat({ value: Benefit })}
          />

          <CoverageOverviewField
            label={t('otherPetsOnThisPolicy')}
            value={PetCoverages
              .map((coverages) => coverages.Pet.Name).join(', ')}
          />
        </div>
      </>
    );
  }

  return loading ? renderShimmer() : (
    <>
      <div className="Coverage-overview-policy-info-container">
        {renderContent()}
      </div>

      {showOnePackDisclaimer ? (
        <p className="Coverage-overview-disclaimer">
          <Trans
            components={{ bold: <strong /> }}
            i18nKey="onePackDisclaimer"
            ns="insurance"
          />
        </p>
      ) : null}
    </>
  );
};

export { CoverageGroupInfoFee };
